import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance from "./api/Axios";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import StudentRegisterPage from "./pages/StudentRegisterPage";
import ProviderRegisterPage from "./pages/ProviderRegisterPage";
import TutorRegisterPage from "./pages/TutorRegisterPage";
import ActivateAccountPage from "./pages/ActivateAccountPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ActivateTestPage from "./pages/ActivateTestPage";
import NotFoundPage from "./pages/NotFoundPage";
import VerifyEmailPage from "./components/VerifyEmailPage";
import PrivateRoute from "./routes/PrivateRoute";
import StudentLayout from "./layouts/StudentLayout";
import StaffLayout from "./layouts/StaffLayout";
import ProviderLayout from "./layouts/ProviderLayout";
import PrimaryRepresentativeLayout from "./layouts/PrimaryRepresentativeLayout";
import SecondaryRepresentativeLayout from "./layouts/SecondaryRepresentativeLayout";
import BMOOfficerLayout from "./layouts/BMOOfficerLayout";
import BMOUserAdminLayout from "./layouts/BMOUserAdminLayout";
import InspectorLayout from "./layouts/InspectorLayout";
import TutorProviderLayout from "./layouts/TutorProviderLayout";
import TutorLayout from "./layouts/TutorLayout";
import GeneralDashboardLayout from "./layouts/GeneralDashboardLayout";
import StudentDashboard from "./views/Student/StudentDashboard";
import StudentBookings from "./views/Student/StudentBookings";
import InspectorDashboard from "./views/Inspector/InspectorDashboard";
import PendingInspections from "./views/Inspector/PendingInspections";
import PassedProperties from "./views/Inspector/PassedProperties";
import PropertyPassedRooms from "./views/Inspector/PropertyPassedRooms";
import AccommodationProviderDashboard from "./views/AccomodationProvider/AccomodationProviderDashboard";
import LocalAmenities from "./views/AccomodationProvider/LocalAmenities";
import CreateRoomType from "./views/AccomodationProvider/CreateRoomType";
import ProviderPropertyManagement from "./views/AccomodationProvider/ProviderPropertyManagement";
import ProviderProperties from "./views/AccomodationProvider/ProviderProperties";
import ProviderManageProperty from "./views/AccomodationProvider/ProviderManageProperty";
import ProviderManageRoom from "./views/AccomodationProvider/ProviderManageRoom";
import ConfigureBlocks from "./views/AccomodationProvider/ConfigureBlocks";
import MaintainBlock from "./views/AccomodationProvider/MaintainBlock";
import ConfigureFloors from "./views/AccomodationProvider/ConfigureFloors";
import MaintainFloor from "./views/AccomodationProvider/MaintainFloor";
import ConfigureRooms from "./views/AccomodationProvider/ConfigureRooms";
import ProviderAddProperty from "./views/AccomodationProvider/ProviderAddProperty";
import ProviderAddPropertyAddress from "./views/AccomodationProvider/ProviderAddPropertyAddress";
import ProviderAddPropertyContact from "./views/AccomodationProvider/ProviderAddPropertyContact";
import ProviderAddPropertyCampuses from "./views/AccomodationProvider/ProviderAddPropertyCampuses";
import ProviderAddPropertyBedAllocation from "./views/AccomodationProvider/ProviderAddPropertyBedAllocation";
import ProviderRequestInspection from "./views/AccomodationProvider/ProviderRequestInspection";
import ProviderPropertyOwnership from "./views/AccomodationProvider/ProviderPropertyOwnership";
import ProviderOperationalStandards from "./views/AccomodationProvider/ProviderOperationalStandards";
import ProviderPoliciesInsurances from "./views/AccomodationProvider/ProviderPoliciesInsurances";
import ProviderBookings from "./views/AccomodationProvider/ProviderBookings";
import StudentDetailsPage from "./views/AccomodationProvider/StudentDetailsPage";
import BackOfficeDashboard from "./views/BackOffice/BackOfficeDashboard";
import CreateTutoringAgent from "./views/BackOffice/CreateTutoringAgent";
import BursaryComponents from "./views/BackOffice/BursaryComponents";
import GlobalAmenities from "./views/BackOffice/GlobalAmenities";
import TutoringProviders from "./views/BackOffice/TutoringProviders";
import TutoringProviderDetails from "./views/BackOffice/TutoringProviderDetails";
import Subjects from "./views/BackOffice/Subjects";
import Institutions from "./views/BackOffice/Institutions";
import PrimaryRepresentativeDashboard from "./views/PrimaryRepresentative/PrimaryRepresentativeDashboard";
import SecondaryRepresentativeDashboard from "./views/SecondaryRepresentative/SecondaryRepresentativeDashboard";
import BMOOfficerDashboard from "./views/BMOOfficer/BMOOfficerDashboard";
import BMOUserAdminDashboard from "./views/BMOUserAdmin/BMOUserAdminDashboard";
import GeneralDashboard from "./views/General/GeneralDashboard";
import TutorProviderDashboard from "./views/TutorProvider/TutorProviderDashboard";
import ManageTutors from "./views/TutorProvider/ManageTutors";
import TutorDetails from "./views/TutorProvider/TutorDetails";
import TutorDashboard from "./views/Tutor/TutorDashboard";
import TutorSubjects from "./views/Tutor/TutorSubjects";
import TutorHomePage from "./TutorPages/TutorHomePage";
import ManageInstitution from "./views/ui/ManageInstitution";
import ManageCampuses from "./views/ui/ManageCampuses";
import ManageProviders from "./views/BackOffice/ManageProviders";
import ManagePropertyApplications from "./views/BackOffice/ManagePropertyApplications";
import PropertyOwnershipReview from "./views/BackOffice/PropertyOwnershipReview";
import PropertyPoliciesInsuranceReview from "./views/BackOffice/PropertyPoliciesInsuranceReview";
import PropertyOperationalStandardsReview from "./views/BackOffice/PropertyOperationalStandardsReview";
import ProviderDetailsPage from "./views/BackOffice/ProviderDetailsPage";
import ManageStudents from "./views/ui/ManageStudents";
import Bookings from "./views/BackOffice/Bookings";
import CreateBMO from "./views/BackOffice/CreateBMO";
import ManageBMOs from "./views/BackOffice/ManageBMOs";
import CreateRepresentatives from "./views/BackOffice/CreateRepresentatives";
import ManageRepresentatives from "./views/BackOffice/ManageRepresentatives";
import ManageFunders from "./views/Representatives/ManageFunders";
import BackOfficeManageFunders from "./views/BackOffice/ManageFunders";
import CreateFunder from "./views/Representatives/CreateFunder";
import AddFunderOfficer from "./views/Representatives/AddFunderOfficer";
import PermissionManagementPage from "./pages/PermissionManagementPage";
import BMOPermissionManagementPage from "./pages/BMOPermissionManagementPage";
import CreateBursary from "./components/CreateBursary";
import ManageBursaries from "./views/Representatives/ManageBursaries";
import BursaryDetail from "./views/Representatives/BursaryDetail";
import BeneficiaryDetail from "./views/Representatives/BeneficiaryDetail";
import BeneficiaryEntitlements from "./views/Representatives/BeneficiaryEntitlements";
import GenerateVouchers from "./views/Representatives/GenerateVouchers";
import AccommodationVoucher from "./views/Representatives/AccommodationVoucher";
import AddBeneficiary from "./views/Representatives/AddBeneficiary";
import ManageBMOOfficers from "./views/Representatives/ManageBMOOfficers";
import BMOComponents from "./views/BMOUserAdmin/BursaryComponents";
import PropertySearchResults from "./pages/PropertySearchResults";
import PropertyBookingPage from "./pages/PropertyBookingPage";
import HomePageJSON from "./pages/HomePageJSON";
import PropertySearchResultsJSON from "./pages/PropertySearchResultsJSON";

const App = () => {
  // Initialize CSRF token on app startup
  useEffect(() => {
    const initCSRF = async () => {
      try {
        await axiosInstance.get('/api/csrf/');
      } catch (error) {
        console.warn('Failed to initialize CSRF token:', error);
      }
    };
    
    initCSRF();
  }, []);

  return (
    <div className="dark">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/StudentRegister" element={<StudentRegisterPage />} />
        <Route path="/ProviderRegister" element={<ProviderRegisterPage />} />
        <Route path="/TutorRegister" element={<TutorRegisterPage />} />
        <Route path="/property-search-results" element={<PropertySearchResults />} />
        <Route path="/property-booking" element={<PropertyBookingPage />} />
        <Route path="/json" element={<HomePageJSON />} />
        <Route path="/json-property-search-results" element={<PropertySearchResultsJSON />} />
        <Route path="/verify-email/:uid/:token" element={<VerifyEmailPage />} />
        <Route path="/activate-account/:token" element={<ActivateAccountPage />} />
        <Route path="/activate-test/:token" element={<ActivateTestPage />} />
        
        {/* Protected General Dashboard Routes - All user types except back_office and bmo_user_admin */}
        <Route element={<PrivateRoute allowedUserTypes={[
          'student', 
          'accommodation_provider',
          'primary_representative', 
          'secondary_representative', 
          'bmo_officer',
          'funder_primary_representative',
          'funder_secondary_representative',
          'funder_officer'
        ]} />}>
          <Route path="/general-dashboard" element={<GeneralDashboardLayout />}>
            <Route index element={<GeneralDashboard />} />
            <Route path="profile" element={<GeneralDashboard />} />
            <Route path="documents" element={<GeneralDashboard />} />
            <Route path="notifications" element={<GeneralDashboard />} />
            <Route path="settings" element={<GeneralDashboard />} />
            
            {/* User Management */}
            <Route path="users" element={<GeneralDashboard />} />
            <Route path="user-permissions" element={<BMOPermissionManagementPage />} />
            
            {/* Bookings Management */}
            <Route path="bookings" element={<Bookings />} />
            
            {/* Funders Management */}
            <Route path="funders" element={<ManageFunders />} />
            <Route path="funders/create" element={<CreateFunder />} />
            <Route path="funders/add-officer/:funderId" element={<AddFunderOfficer />} />
            <Route path="funder-officers" element={<GeneralDashboard />} />
            <Route path="funder-representatives" element={<GeneralDashboard />} />
            <Route path="funder-applications" element={<GeneralDashboard />} />
            <Route path="funder-agreements" element={<GeneralDashboard />} />
            <Route path="funder-payments" element={<GeneralDashboard />} />
            
            {/* Bursaries */}
            <Route path="bursaries" element={<ManageBursaries />} />
            <Route path="bursaries/:id" element={<BursaryDetail />} />
            <Route path="bursaries/:bursaryId/add-beneficiary" element={<AddBeneficiary />} />
            <Route path="CreateBursary" element={<CreateBursary />} />
            
            {/* Beneficiaries */}
            <Route path="beneficiaries/view/:beneficiaryId" element={<BeneficiaryDetail />} />
            <Route path="beneficiaries/entitlements/:beneficiaryId" element={<BeneficiaryEntitlements />} />
            <Route path="beneficiaries/generate-vouchers/:beneficiaryId" element={<GenerateVouchers />} />
            <Route path="beneficiaries/accommodation-voucher/:beneficiaryId" element={<AccommodationVoucher />} />
            
            {/* Reports */}
            <Route path="reports/funders" element={<GeneralDashboard />} />
            <Route path="reports/financial" element={<GeneralDashboard />} />
            <Route path="reports/students" element={<GeneralDashboard />} />
            
            {/* Legacy routes for existing functionality */}
            <Route path="ManageFunders" element={<ManageFunders />} />
            <Route path="CreateFunder" element={<CreateFunder />} />
            <Route path="AddFunderOfficer/:funderId" element={<AddFunderOfficer />} />
          </Route>
        </Route>

        {/* Protected Student Routes - Redirect to General Dashboard */}
        <Route element={<PrivateRoute allowedUserTypes={['student']} />}>
          <Route path="/student-dashboard" element={<StudentLayout />}>
            <Route index element={<StudentDashboard />} />
            <Route path="contracts" element={<StudentBookings />} />
          </Route>
        </Route>

        {/* Protected Accommodation Provider Routes */}
        <Route element={<PrivateRoute allowedUserTypes={['accommodation_provider']} />}>
          <Route path="/provider-dashboard" element={<ProviderLayout />}>
            <Route index element={<AccommodationProviderDashboard />} />
            <Route path="LocalAmenities" element={<LocalAmenities />} />
            <Route path="bookings" element={<ProviderBookings />} />
            <Route path="student-details" element={<StudentDetailsPage />} />
            <Route path="create-room-type/:propertyId" element={<CreateRoomType />} />
            <Route path="configure-blocks/:propertyId" element={<ConfigureBlocks />} />
            <Route path="configure-blocks/:propertyId/maintain/:blockId" element={<MaintainBlock />} />
            <Route path="configure-blocks/:propertyId/block/:blockId/configure-floors" element={<ConfigureFloors />} />
            <Route path="configure-blocks/:propertyId/block/:blockId/configure-floors/:floorId/maintain" element={<MaintainFloor />} />
            <Route path="configure-blocks/:propertyId/block/:blockId/configure-floors/:floorId/configure-rooms" element={<ConfigureRooms />} />
          </Route>
          <Route path="/provider-property-management" element={<ProviderLayout />}>
            <Route index element={<ProviderPropertyManagement />} />
          </Route>
          <Route path="/provider-properties" element={<ProviderLayout />}>
            <Route index element={<ProviderProperties />} />
          </Route>
          <Route path="/provider-add-property" element={<ProviderLayout />}>
            <Route index element={<ProviderAddPropertyAddress />} />
          </Route>
          <Route path="/provider-add-property-room-details" element={<ProviderLayout />}>
            <Route index element={<ProviderAddProperty />} />
          </Route>
          <Route path="/provider-add-property-contact" element={<ProviderLayout />}>
            <Route index element={<ProviderAddPropertyContact />} />
          </Route>
          <Route path="/provider-add-property-campuses" element={<ProviderLayout />}>
            <Route index element={<ProviderAddPropertyCampuses />} />
          </Route>
          <Route path="/provider-add-property-bed-allocation" element={<ProviderLayout />}>
            <Route index element={<ProviderAddPropertyBedAllocation />} />
          </Route>
          <Route path="/provider-dashboard/manage-property/:id" element={<ProviderLayout />}>
            <Route index element={<ProviderManageProperty />} />
          </Route>
          <Route path="/provider-dashboard/manage-room/:id" element={<ProviderLayout />}>
            <Route index element={<ProviderManageRoom />} />
          </Route>
          <Route path="/provider-request-inspection" element={<ProviderLayout />}>
            <Route index element={<ProviderRequestInspection />} />
          </Route>
          <Route path="/provider-property-ownership/:propertyId" element={<ProviderLayout />}>
            <Route index element={<ProviderPropertyOwnership />} />
          </Route>
          <Route path="/provider-operational-standards/:propertyId" element={<ProviderLayout />}>
            <Route index element={<ProviderOperationalStandards />} />
          </Route>
          <Route path="/provider-policies-insurances/:propertyId" element={<ProviderLayout />}>
            <Route index element={<ProviderPoliciesInsurances />} />
          </Route>
        </Route>

        {/* Protected Back Office Routes */}
        <Route element={<PrivateRoute allowedUserTypes={['back_office']} />}>
          <Route path="/backoffice-dashboard" element={<StaffLayout />}>
            <Route index element={<BackOfficeDashboard />} />
            <Route path="create-tutoring-agent" element={<CreateTutoringAgent />} />
            <Route path="Institutions" element={<Institutions />} />
            <Route path="ManageInstitutions" element={<ManageInstitution />} />
            <Route path="ManageCampuses" element={<ManageCampuses />} />
            <Route path="ManageProviders" element={<ManageProviders />} />
            <Route path="ManageProviders/:providerId" element={<ProviderDetailsPage />} />
            <Route path="ManagePropertyApplications" element={<ManagePropertyApplications />} />
            <Route path="property-ownership-review/:propertyId" element={<PropertyOwnershipReview />} />
            <Route path="property-policies-review/:propertyId" element={<PropertyPoliciesInsuranceReview />} />
            <Route path="property-operational-review/:propertyId" element={<PropertyOperationalStandardsReview />} />
            <Route path="ManageStudents" element={<ManageStudents />} />
            <Route path="Bookings" element={<Bookings />} />
            <Route path="CreateBMO" element={<CreateBMO />} />
            <Route path="ManageBMOs" element={<ManageBMOs />} />
            <Route path="ManageFunders" element={<BackOfficeManageFunders />} />
            <Route path="BursaryComponents" element={<BursaryComponents />} />
            <Route path="GlobalAmenities" element={<GlobalAmenities />} />
            <Route path="TutoringProviders" element={<TutoringProviders />} />
            <Route path="tutoring-provider/:id" element={<TutoringProviderDetails />} />
            <Route path="Subjects" element={<Subjects />} />
            <Route path="CreateRepresentatives" element={<CreateRepresentatives />} />
            <Route path="ManageRepresentatives" element={<ManageRepresentatives />} />
            <Route path="PermissionManagement" element={<PermissionManagementPage />} />
          </Route>
        </Route>

        {/* Protected Primary Representative Routes - Now using General Dashboard */}
        {/* 
        <Route element={<PrivateRoute allowedUserTypes={['primary_representative']} />}>
          <Route path="/primary-representative-dashboard" element={<PrimaryRepresentativeLayout />}>
            <Route index element={<PrimaryRepresentativeDashboard />} />
            <Route path="ManageFunders" element={<ManageFunders />} />
            <Route path="CreateFunder" element={<CreateFunder />} />
            <Route path="AddFunderOfficer/:funderId" element={<AddFunderOfficer />} />
          </Route>
        </Route>
        */}

        {/* Protected Secondary Representative Routes - Now using General Dashboard */}
        {/* 
        <Route element={<PrivateRoute allowedUserTypes={['secondary_representative']} />}>
          <Route path="/secondary-representative-dashboard" element={<SecondaryRepresentativeLayout />}>
            <Route index element={<SecondaryRepresentativeDashboard />} />
            <Route path="ManageFunders" element={<ManageFunders />} />
            <Route path="CreateFunder" element={<CreateFunder />} />
            <Route path="AddFunderOfficer/:funderId" element={<AddFunderOfficer />} />
          </Route>
        </Route>
        */}

        {/* Protected BMO Officer Routes - Now using General Dashboard */}
        {/* 
        <Route element={<PrivateRoute allowedUserTypes={['bmo_officer']} />}>
          <Route path="/bmo-officer-dashboard" element={<BMOOfficerLayout />}>
            <Route index element={<BMOOfficerDashboard />} />
          </Route>
        </Route>
        */}

        {/* Protected BMO User Admin Routes */}
        <Route element={<PrivateRoute allowedUserTypes={['bmo_user_admin']} />}>
          <Route path="/bmo-user-admin-dashboard" element={<BMOUserAdminLayout />}>
            <Route index element={<BMOUserAdminDashboard />} />
            <Route path="UserPermissions" element={<BMOPermissionManagementPage />} />
            <Route path="CreateBursary" element={<CreateBursary />} />
            <Route path="BursaryComponents" element={<BMOComponents />} />
            <Route path="ManageBMOOfficers" element={<ManageBMOOfficers />} />
          </Route>
        </Route>

        {/* Protected Inspector Routes */}
        <Route element={<PrivateRoute allowedUserTypes={['inspector']} />}>
          <Route path="/inspector-dashboard" element={<InspectorLayout />}>
            <Route index element={<InspectorDashboard />} />
            <Route path="pending-inspections" element={<PendingInspections />} />
            <Route path="passed-properties" element={<PassedProperties />} />
            <Route path="property-passed-rooms/:propertyId" element={<PropertyPassedRooms />} />
            <Route path="inspection-schedule" element={<InspectorDashboard />} />
            <Route path="property-search" element={<InspectorDashboard />} />
            <Route path="inspection-history" element={<InspectorDashboard />} />
            <Route path="submit-report" element={<InspectorDashboard />} />
            <Route path="profile" element={<InspectorDashboard />} />
            <Route path="settings" element={<InspectorDashboard />} />
            <Route path="inspection/:id" element={<InspectorDashboard />} />
          </Route>
        </Route>

        {/* Protected Tutoring Provider Routes */}
        <Route element={<PrivateRoute allowedUserTypes={['tutoring_agent']} />}>
          <Route path="/tutor-provider-dashboard" element={<TutorProviderLayout />}>
            <Route index element={<TutorProviderDashboard />} />
            <Route path="tutors" element={<ManageTutors />} />
            <Route path="tutors/:id" element={<TutorDetails />} />
          </Route>
        </Route>

        {/* Protected Tutor Routes */}
        <Route element={<PrivateRoute allowedUserTypes={['tutor']} />}>
          <Route path="/tutor-dashboard" element={<TutorLayout />}>
            <Route index element={<TutorHomePage />} />
            <Route path="subjects" element={<TutorSubjects />} />
          </Route>
        </Route>

        {/* ute>

        {/* TODO: Add Funder User Type Routes */}
        {/* 
        <Route element={<PrivateRoute allowedUserTypes={['funder_primary_representative']} />}>
          <Route path="/funder-primary-representative-dashboard" element={<FunderPrimaryRepresentativeLayout />}>
            <Route index element={<FunderPrimaryRepresentativeDashboard />} />
          </Route>
        </Route>

        <Route element={<PrivateRoute allowedUserTypes={['funder_secondary_representative']} />}>
          <Route path="/funder-secondary-representative-dashboard" element={<FunderSecondaryRepresentativeLayout />}>
            <Route index element={<FunderSecondaryRepresentativeDashboard />} />
          </Route>
        </Route>

        <Route element={<PrivateRoute allowedUserTypes={['funder_officer']} />}>
          <Route path="/funder-officer-dashboard" element={<FunderOfficerLayout />}>
            <Route index element={<FunderOfficerDashboard />} />
          </Route>
        </Route>
        */}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

export default App;